{
	"requests_one": "Atenção! Você possui {{value}} solicitação de saque de vendor pendentes",
	"requests_other": "Atenção! Você possui {{value}} solicitações de saque de vendor pendentes",
	"isApproved": "Atenção! Esse local se encontra em estado de pré-aprovação, não será possivel abrir eventos até que a aprovação seja feita.",
	"certificatesAboutToExpire": "Os certificados digitais dos perfis fiscais {{value}} irão expirar em menos de 30 dias!",
	"expiredCertificates": "Os certificados digitais dos perfis fiscais {{value}} expiraram!",
	"blockedPlace": "O local {{placeName}} está bloqueado",
	"blockedPlaces": "Os locais {{placeName}} estão bloqueados"
}
